module.exports = __webpack_public_path__ + "static/media/client-appier.422aeaeb.png";